import React, { useState, useEffect, useRef } from "react";
import FormTextField from "../../components/general/FormTextField";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import {
    Col,
    Drawer,
    Tabs,
    Row,
    Table,
    Collapse,
    Button,
    message,
    Badge,
    Tag,
    Modal,
    Input,
    Typography,
    Space,
    List,
    Switch
} from "antd";
import { EyeOutlined, LoadingOutlined, BellOutlined, SearchOutlined } from "@ant-design/icons";
import FormSelect from "../../components/general/FormSelect";
import { useSelector, useDispatch } from "react-redux";
import FormButton from "../../components/general/FormButton";
import { postRequest } from "../../services/mainApp.service";
import ViewOrderModal from "../../components/PosComponentsFood/ViewOrderModal";
import DayShiftCounterModal from "./DayShiftCounterModal";
import FormTileButton from "../../components/general/FormTileButton";
import UpdateTableWaiterRiderModal from "./UpdateTableWaiterRiderModal";
import { useNavigate, useLocation } from "react-router-dom";
import { use } from "react";
import { NewOrderDialog } from "../../components/NewOrderComponents/NewOrderDialog";
import useFeatureCheck from "../../customHooks/useFeatureCheck";
import AuthLoginModal from "./AuthLoginModal";
import KotPrint from "../../components/NewOrderComponents/Kot";
import { TERMINAL_UNIQUE_ID } from '../../common/SetupMasterEnum';
import OrderCheckoutBill from "../../components/NewComponents/OrderCheckoutBill";
import SalesReturnModal from "./SalesReturnModal";
import PettyCashPage from "../PettyCash/PettyCashPage";

const { Panel } = Collapse;


function OrderRecall() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const checkFeatureAuth = useFeatureCheck();

    const [allOrders, setAllOrders] = useState([]);
    const [orderStatusList, setOrderStatusList] = useState([]);
    const [isAllOrders, setIsAllOrders] = useState(true);
    const [selectedOrderStatus, setSelectedOrderStatus] = useState("");
    const [branchList, setBranchList] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [orderSourceList, setOrderSourceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewOrderData, setViewOrderData] = useState(null);
    const [viewOrder, setViewOrder] = useState(false);
    const [paymentTypeList, setPaymentTypeList] = useState([]);
    const [riders, SetRiders] = useState([]);

    // new Orders data
    const [newOrders, setNewOrders] = useState([]);


    const [NewviewOrder, setNewViewOrder] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState({});
    const [popoverData, setPopoverData] = useState({});


    //  Redux
    const userData = useSelector((state) => state.authReducer);


    const { userBranchList } = useSelector((state) => state.authReducer);
    const { selectedOrder, cancelOrderStatusObj, FromDate, ToDate, controller } =
        useSelector((state) => state.PointOfSaleReducer);

    const BASE_URL = process.env.REACT_APP_BASEURL;


    const [data, setData] = useState({
        areaId: null,
        StatusId: null,
        orderNumber: null,
        CustomerId: null,
        customerName: "",
        CustomerPhone: null,
        cityId: null,
        DateFrom: "",
        DateTo: "",
    });

    const { RefreshStats } = useSelector((state) => state.RefreshReducer);
    const [DayShiftCounterData, setDayShiftCounterData] = useState([]);
    const [isDayShiftCounterModalVisible, setIsDayShiftCounterModalVisible] = useState(false);
    const [orderModeList, setOrderModeList] = useState([]);
    const [selectedOrderMode, setSelectedOrderMode] = useState("");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const tableRef = useRef(null);
    const [tables, setTableList] = useState([]);
    const [updateTableWaiterRiderModalObj, setUpdateTableWaiterRiderModalObj] = useState({});
    const [tableWaiterRiderModalOpen, setTableWaiterRiderModalOpen] = useState(false);

    const [selectedCurrentOrder, setSelectedCurrentOrder] = useState([]);
    const [waiters, setWaiterList] = useState([]);

    // Column filter state
    const [columnFilters, setColumnFilters] = useState({
        OrderNumber: "",
        BranchName: "",
        PhoneNumber: "",
        CustomerName: "",
        OrderDateTime: "",
        OrderDeliveryDateTime: "",
        TotalAmountWithGST: "",
        PaymentMode: "",
        OrderSourceValue: "",
        OrderStatus: "",
        WaiterRiderName: "",
        TableName: "",
    });

    const [isEnableButton, setIsEnableButton] = useState(false);
    const [isEnableGeneralOrderBtns, setIsEnableGeneralOrderBtns] = useState(false);
    const [isEnableDineInOrderBtns, setIsEnableDineInOrderBtns] = useState(false);
    const [isEnableTakeAwayOrderBtns, setIsEnableTakeAwayOrderBtns] = useState(false);
    const [isEnableDeliveryOrderBtns, setIsEnableDeliveryOrderBtns] = useState(false);
    const [isEnableOrderTransfer, setIsEnableOrderTransfer] = useState(false);
    const [isEnableTableMerge, setIsEnableTableMerge] = useState(false);
    const [isEnableDuplicateCheckoutBill, setisEnableDuplicateCheckoutBill] = useState(false);
    const [isEnableSaleReturn, setIsEnableSaleReturn] = useState(false);

    // const { POSData } = useSelector((state) => state.POSReducer);
    // const { DayShiftCounter, TerminalList } = POSData ?? {};

    const { TerminalList, DayShiftCounter, TerminalOrderModeList } = useSelector((state) => state.POSReducer);

    const [isEnableButton_NewOrder, setIsEnableButton_NewOrder] = useState(false);
    const [isDayShiftCounterCloseModalVisible, setIsDayShiftCounterCloseModalVisible] = useState(false);
    const [isMergeTableExist, setIsMergeTableExist] = useState(false);
    const [isNewOrderOpen, setIsNewOrderOpen] = useState(false);
    const [orderCancelReason, setOrderCancelReasonList] = useState([]);
    const [isAuthenticate, setIsAuthenticate] = useState(false);
    const [visibleAuthModal, setVisibleAuthModal] = useState(false);
    const [featureName, setFeatureName] = useState("");
    const [pendingAction, setPendingAction] = useState(null);
    const [isKotLoading, setIsKotLoading] = useState(false);
    const [isDepartmentKotLoading, setIsDepartmentKotLoading] = useState(false);
    const [kotPrintData, setKotPrintData] = useState(null);
    const [checkoutBillData, setCheckoutBillData] = useState(null);
    const checkoutBillRef = useRef(null);
    const menuName = location.pathname.split("/").filter(Boolean).length ?
        location.pathname.split("/").filter(Boolean)[location.pathname.split("/").filter(Boolean).length - 1] :
        "OrderRecall";
    const [posTerminalList, setPosTerminalList] = useState([]);
    const [showClosedOrderList, setShowClosedOrderList] = useState(false);
    const [saleReturnModal, setSaleReturnModal] = useState(false);
    const [pettyCashModal, setPettyCashModal] = useState(false);

    // const popupIntialFormValues = {
    //     OrderMasterId: null,
    //     OperationId: null,
    //     UserId: null,
    //     TableId: null,
    //     WaiterId: null,
    //     RiderId: null,
    //     OrderModeId: null,
    // };

    // A function to map PaymentTypeId to PaymentMode
    const getPaymentMode = (paymentTypeId) => {
        const paymentType = paymentTypeList.find(
            (type) => type.PaymentModeId === paymentTypeId
        );
        return paymentType ? paymentType.PaymentMode : "Unknown";
    };


    // Map statuses to styles for UI/UX clarity
    const statusColors = {
        Pending: "orange",
        Confirmed: "blue",
        Process: "cyan",
        Dispatch: "purple",
        Delivered: "green",
        Cancel: "red",
        Paid: "gold",
        Ready: "lime",
    };

    const columns = [
        {
            title: "Order Number",
            dataIndex: "OrderNumber",
            key: "OrderNumber",
            render: (text, item) => (

                <>
                    <Button ghost type="primary"
                        onClick={() => {
                            {

                                (item?.IsClosed || item?.IsCancelable) ? message.error("This order cannot be recalled.") :
                                    navigate('/orderBooking', {
                                        state: { order: item }
                                    });
                            }
                        }
                        }
                    >
                        {
                            item?.OrderNumber
                        }
                    </Button>
                </>
            ),
        },
        // {
        //     title: "Branch",
        //     dataIndex: "BranchName",
        //     key: "BranchName",
        // },
        {
            title: "Customer Name",
            dataIndex: "CustomerName",
            key: "CustomerName",
        },
        {
            title: "Phone",
            dataIndex: "PhoneNumber",
            key: "PhoneNumber",
        },

        {
            title: "Order Date Time",
            dataIndex: "OrderDateTime",
            key: "OrderDateTime",
        },
        {
            title: "Table",
            dataIndex: "TableName",
            key: "TableName",
        },
        {
            title: "Waiter / Rider",
            dataIndex: "WaiterRiderName",
            key: "WaiterRiderName",
            render: (text, record) => {
                // If OrderModeId is 109 (Dine In), show WaiterName
                // Otherwise show RiderName (for Delivery and other modes)
                if (record.OrderModeId === 109) {
                    return record.WaiterName || "-";
                } else {
                    return record.RiderName || "-";
                }
            },
        },

        // {
        //     title: "Delivery Date Time",
        //     dataIndex: "OrderDeliveryDateTime",
        //     key: "OrderDeliveryDateTime",
        // },
        {
            title: "Amount",
            dataIndex: "TotalAmountWithGST",
            key: "TotalAmountWithGST",
            render: (text, record) => {

                return record.TotalAmountWithGST.toFixed(2);

            },
        },
        // {
        //     title: "Payment Mode",
        //     dataIndex: "PaymentMode",
        //     key: "PaymentMode",
        //     // render: (paymentTypeId) => getPaymentMode(paymentTypeId),
        //     // render: (status) => (
        //     //   <p>{status?.PaymentMode}</p>
        //     // ),
        // },
        // {
        //   title: "Delivery Time(Mins)",
        //   dataIndex: "DeliveryTime",
        //   key: "DeliveryTime",
        // },
        {
            title: "Order Source",
            dataIndex: "OrderSourceValue",
            key: "OrderSourceValue",
        },
        {
            title: "Status",
            dataIndex: "OrderStatus",
            key: "OrderStatus",
            render: (status) => (
                <Tag color={statusColors[status] || "default"}>{status}</Tag>
            ),
        },
        {
            title: "Action",
            dataIndex: "x",
            key: "x",
            render: (text, item) => (
                <>
                    <Button type="text" onClick={() => getOrderDetail(item)}>
                        <EyeOutlined />
                    </Button>
                    <ViewOrderModal
                        data={viewOrderData}
                        viewOrder={viewOrder}
                        toggleViewOrder={toggleViewOrder}
                        isMainPage={true}
                        ridersData={riders}
                        branchList={branchList}
                        fetchLatestOrders={fetchDataFromApi}
                    />
                </>
            ),
        },
    ];

    const initialFormValues = {
        BranchId: null,
        AreaId: null,
        OrderNumber: "",
        CustomerId: null,
        CustomerName: "",
        CustomerPhone: "",
        OrderModeId: null,
        OrderSourceId: null,
        DateFrom: "",
        DateTo: "",
        StatusId: null,
        CityId: null,
    };

    // HANDLE SEARCH SUBMIT
    const [filteredData, setFilteredData] = useState([]);


    const [searchFields, setSearchFields] = useState({
        BranchId: null,
        AreaId: null,
        OrderNumber: "",
        CustomerId: null,
        CustomerName: "",
        CustomerPhone: "",
        OrderModeId: null,
        OrderSourceId: null,
        DateFrom: null,
        DateTo: null,
        StatusId: null,
    });

    const DateRefFrom = useRef({});
    const DateRefTo = useRef({});


    const fetchDataFromApi = (closeOrders = false) => {
        setLoading(true);
        postRequest("PosOrders", {
            OperationId: 1,
            UserIP: "12.1.1.2",
            // BranchId:
            //     selectedOrder?.BranchId || userBranchList.length === 1
            //         ? userBranchList[0].BranchId
            //         : null,
            BranchId: userBranchList.length === 1
                ? userBranchList[0].BranchId : searchFields?.BranchId,
            AreaId: searchFields?.AreaId,
            StatusId: searchFields.StatusId,
            OrderNumber: searchFields.OrderNumber || "%%",
            CustomerName: searchFields.CustomerName || "%%",
            CustomerPhone: searchFields.CustomerPhone || "%%",
            DateFrom: searchFields.DateFrom || null,
            DateTo: searchFields.DateTo || null,
            CityId: userBranchList[0]?.CityId,
            CompanyId: userData.CompanyId,
            userId: userData.UserId,
            OrderModeId: searchFields.OrderModeId || null,
            OrderSourceId: searchFields.OrderSourceId || null,
            IsPos: true,
            IsCloseOrders: closeOrders ? true : false,
        })
            .then((response) => {

                setLoading(false);
                if (response.data.error === true) {
                    message.error(response.data.errorMessage);
                    return;
                }

                if (response.data.response === false) {
                    message.error(response.data.DataSet.Table.errorMessage);
                    return;
                }

                const data = response.data.DataSet;
                const { Table2, Table3, Table4, Table7, Table10, Table, Table13,
                    Table14, Table15, Table16, Table17, Table18, Table12, Table19, Table20, Table21 } = data;
                SetRiders(Table14 || []);
                setNewOrders(Table13 || []);
                // setFilteredData(Table || []);

                setOrderStatusList(Table2 || []);
                setAllOrders(Table || []);

                setBranchList(Table3 || []);
                setAreaList(Table4 || []);
                setPaymentTypeList(Table7 || []);
                setOrderSourceList(Table10 || []);
                setDayShiftCounterData(Table15 || []);
                setOrderModeList(Table18 || []);
                setTableList(Table12 || []);
                setWaiterList(Table19 || []);
                setOrderCancelReasonList(Table20 || []);
                setPosTerminalList(Table17 || []);


                dispatch({ type: "POS_DAY_SHIFT_TERMINAL", payload: Table15 || [] });
                dispatch({ type: "POS_SHIFT_LIST", payload: Table16 || [] });
                dispatch({ type: "POS_TERMINAL_LIST", payload: Table17 || [] });
                dispatch({ type: "POS_TERMINAL_ORDERMODE", payload: Table21 || [] });

                let selectedTerminalId = localStorage.getItem('SelectedTerminalId');

                if (parseInt(selectedTerminalId) > 0) {
                    let terminalObj = Table15;
                    let terminalUniqueKey = localStorage.getItem(TERMINAL_UNIQUE_ID);

                    if (terminalObj != undefined) {
                        const updatedData = terminalObj?.map(item => {
                            if (item.TerminalId === parseInt(selectedTerminalId)
                                && item.UniqueId === terminalUniqueKey) {

                                if (item?.IsCounterOpen == true) {
                                    setIsEnableButton_NewOrder(true);
                                }
                                else {
                                    setIsEnableButton_NewOrder(false);
                                }

                                return {
                                    ...item,
                                    IsSelected: true,
                                };
                            } else {
                                return {
                                    ...item,
                                    IsSelected: false,
                                };
                            }
                        });

                        dispatch({ type: "POS_DAY_SHIFT_TERMINAL", payload: updatedData || [] });
                    }
                }

                // Bind orders with current showClosedOrderList state
                bindOrders(Table || [], closeOrders);

            })
            .catch((error) => {
                setLoading(false);
                console.error("Error:", error);
            });
    };

    useEffect(() => {


        fetchDataFromApi();


    }, []);

    useEffect(() => {

        if (RefreshStats == 1) {

            fetchDataFromApi();
            dispatch({ type: "REFRESH_STATS", payload: 0 });
        }

    }, [RefreshStats]);

    useEffect(() => {
        if (checkoutBillData && checkoutBillData.orderDetails && checkoutBillData.orderItems && checkoutBillData.orderItems.length > 0) {
            // Use requestAnimationFrame to stay in user action context
            requestAnimationFrame(() => {
                setTimeout(() => {
                    if (checkoutBillRef.current) {
                        try {
                            checkoutBillRef.current.print();
                        } catch (error) {
                            console.error("Error printing checkout bill:", error);
                        }
                    }
                }, 500);
            });
        }
    }, [checkoutBillData]);

    // Re-apply filters when columnFilters or showClosedOrderList change
    useEffect(() => {
        if (allOrders && allOrders.length > 0) {
            bindOrders(allOrders, showClosedOrderList);
        }
    }, [columnFilters, showClosedOrderList]);

    useEffect(() => {

        if (DayShiftCounterData?.length > 0) {

            const selectedTerminalId = localStorage.getItem('SelectedTerminalId');

            const obj = DayShiftCounterData?.filter(a => a.TerminalId == selectedTerminalId && a.IsSelected == true);

            if (obj?.length > 0) {
                setIsEnableButton(true);
            }
        }
    }, [DayShiftCounterData]);

    // useEffect(() => {
    //     // console.log("DayShiftCounter:", DayShiftCounter);
    //     if (DayShiftCounter?.length > 0) {

    //     }

    // }, [DayShiftCounter]);

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (tableRef.current && !tableRef.current.contains(event.target)) {
    //             setSelectedRowKeys([]); // Clear selection
    //         }
    //     };

    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, []);

    const applyColumnFilters = (orders) => {
        if (!orders || orders.length === 0) return orders;

        return orders.filter((order) => {
            // Order Number filter
            if (columnFilters.OrderNumber &&
                !String(order.OrderNumber || "").toLowerCase().includes(columnFilters.OrderNumber.toLowerCase())) {
                return false;
            }

            // Branch Name filter
            if (columnFilters.BranchName &&
                !String(order.BranchName || "").toLowerCase().includes(columnFilters.BranchName.toLowerCase())) {
                return false;
            }

            // Phone Number filter
            if (columnFilters.PhoneNumber &&
                !String(order.PhoneNumber || "").includes(columnFilters.PhoneNumber)) {
                return false;
            }

            // Customer Name filter
            if (columnFilters.CustomerName &&
                !String(order.CustomerName || "").toLowerCase().includes(columnFilters.CustomerName.toLowerCase())) {
                return false;
            }

            // Order Date Time filter
            if (columnFilters.OrderDateTime &&
                !String(order.OrderDateTime || "").includes(columnFilters.OrderDateTime)) {
                return false;
            }

            // Delivery Date Time filter
            if (columnFilters.OrderDeliveryDateTime &&
                !String(order.OrderDeliveryDateTime || "").includes(columnFilters.OrderDeliveryDateTime)) {
                return false;
            }

            // Amount filter
            if (columnFilters.TotalAmountWithGST &&
                !String(order.TotalAmountWithGST || "").includes(columnFilters.TotalAmountWithGST)) {
                return false;
            }

            // Payment Mode filter
            if (columnFilters.PaymentMode &&
                !String(order.PaymentMode || "").toLowerCase().includes(columnFilters.PaymentMode.toLowerCase())) {
                return false;
            }

            // Order Source filter
            if (columnFilters.OrderSourceValue &&
                !String(order.OrderSourceValue || "").toLowerCase().includes(columnFilters.OrderSourceValue.toLowerCase())) {
                return false;
            }

            // Order Status filter
            if (columnFilters.OrderStatus &&
                !String(order.OrderStatus || "").toLowerCase().includes(columnFilters.OrderStatus.toLowerCase())) {
                return false;
            }

            // Table Name filter
            if (columnFilters.TableName &&
                !String(order.TableName || "").toLowerCase().includes(columnFilters.TableName.toLowerCase())) {
                return false;
            }

            // Waiter / Rider Name filter
            if (columnFilters.WaiterRiderName) {
                const filterValue = columnFilters.WaiterRiderName.toLowerCase();
                // Check WaiterName for Dine In orders (OrderModeId === 109)
                // Check RiderName for other orders (Delivery, etc.)
                if (order.OrderModeId === 109) {
                    if (!String(order.WaiterName || "").toLowerCase().includes(filterValue)) {
                        return false;
                    }
                } else {
                    if (!String(order.RiderName || "").toLowerCase().includes(filterValue)) {
                        return false;
                    }
                }
            }

            return true;
        });
    };

    const bindOrders = (orders, showClosedOrderList = false) => {

        // setFilteredData(orders || []);

        let processedOrders = orders || [];

        if (TerminalList && TerminalList.length > 0) {
            if (DayShiftCounter && Object.keys(DayShiftCounter).length > 0) {

                const SelectedTerminalDetail = DayShiftCounter?.filter(a => a.IsSelected == true)[0];

                if (SelectedTerminalDetail != undefined && SelectedTerminalDetail?.IsCounterOpen == true) {

                    const terminalObj = TerminalList?.find(a => a.TerminalId == SelectedTerminalDetail?.TerminalId);

                    if (terminalObj && terminalObj.DisplayAllOrders == true) {

                        processedOrders = orders || [];
                    }
                    else if (terminalObj && terminalObj.DisplayAllOrders == false) {

                        processedOrders = orders?.filter(a => a.TerminalDetailId == SelectedTerminalDetail?.TerminalDetailId) || [];
                    }


                    if (TerminalOrderModeList && TerminalOrderModeList.length > 0) {

                        const orderModeArr = TerminalOrderModeList?.filter(a => a.TerminalId == SelectedTerminalDetail?.TerminalId);

                        if (orderModeArr && orderModeArr.length > 0) {

                            setOrderModeList(orderModeArr || []);

                            processedOrders = orders?.filter(o => orderModeArr.some(m => m.OrderModeId === o.OrderModeId)) || [];
                        }

                    }
                }
            }
        }

        // Apply column filters
        const filtered = applyColumnFilters(processedOrders);

        // Helper function to check if a value is falsy (false, null, undefined, 0, "false", "False", etc.)
        const isFalsy = (value) => {
            if (value === false || value === 0 || value === null || value === undefined) {
                return true;
            }
            // Handle string values (case-insensitive)
            if (typeof value === "string") {
                const lowerValue = value.toLowerCase().trim();
                return lowerValue === "false" || lowerValue === "";
            }
            return false;
        };

        setFilteredData(
            (filtered || []).filter((a) => {
                if (!showClosedOrderList) {
                    return isFalsy(a.IsUnconfirm) && isFalsy(a.IsCancelable) && isFalsy(a.IsClosed);
                }
                else {
                    return !isFalsy(a.IsPaid) || !isFalsy(a.IsCancelable) || !isFalsy(a.IsClosed);
                }
            })
        );
    };

    const handleSearchFieldChange = (data) => {
        const { name, value } = data;

        if (
            name === "CustomerName" ||
            name === "CustomerPhone" ||
            name === "OrderNumber"
        ) {
            setSearchFields({ ...searchFields, [name]: value });
        } else if (name === "DateFrom" || name === "DateTo") {
            setSearchFields({ ...searchFields, [name]: value + " 00:00:00.000" });
        } else {
            setSearchFields({ ...searchFields, [name]: value });
        }
    };

    const handleColumnFilterChange = (columnName, value) => {
        setColumnFilters({
            ...columnFilters,
            [columnName]: value,
        });
    };

    const clearAllFilters = () => {
        setColumnFilters({
            OrderNumber: "",
            BranchName: "",
            PhoneNumber: "",
            CustomerName: "",
            OrderDateTime: "",
            OrderDeliveryDateTime: "",
            TotalAmountWithGST: "",
            PaymentMode: "",
            OrderSourceValue: "",
            OrderStatus: "",
            WaiterRiderName: "",
            TableName: "",
        });
    };

    DateRefFrom.current = searchFields.DateFrom;
    DateRefTo.current = searchFields.DateTo;
    /**
     * This function change the state of Select in Search Field
     * @param {{}} data event object of field
     */
    const handleSelectChange = (data) => {
        if (data.value !== null) {
            setSearchFields({ ...searchFields, [data.name]: data.value });
        } else {
            // If the user clears the selection, set the field to null
            setSearchFields({ ...searchFields, [data.name]: null });
        }
    };

    ///      Handle Search Submit ///
    const dateFromRef = useRef(null);
    const dateToRef = useRef(null);


    const handleSearchSubmit = (e) => {
        e.preventDefault();
        // setLoading(true);

        fetchDataFromApi(showClosedOrderList);

    };

    /// Get order Detail
    /// Get order Detail
    const getOrderDetail = (record) => {
        if (!record || !record?.OrderMasterId) {
            return;
        }

        setViewOrder(true);

        postRequest("getOrderDetail", {
            OperationId: 1,
            CompanyId: userData.CompanyId,
            OrderId: record.OrderMasterId,
            UserId: userData.UserId,
            UserIP: "192.1.1.1",
        })
            .then((response) => {
                setViewOrderData(response.data.DataSet);
            })
            .catch((error) => {
                setViewOrder(false);
                console.error(error);
            });
    };


    //// New API
    const getDetail = (record) => {
        if (!record || !record.OrderMasterId) {
            console.error("OrderMasterId is undefined in the record:", record);
            return;
        }

        setPopoverVisible((prevVisible) => ({
            ...prevVisible,
            [record.OrderMasterId]: true,
        }));

        postRequest("getOrderDetail", {
            OperationId: 1,
            CompanyId: userData.CompanyId,
            OrderId: record.OrderMasterId,
            UserId: userData.UserId,
            UserIP: "192.1.1.1",
        })
            .then((response) => {
                setPopoverData((prevData) => ({
                    ...prevData,
                    [record.OrderMasterId]: response.data.DataSet,
                }));
            })
            .catch((error) => {
                setPopoverVisible((prevVisible) => ({
                    ...prevVisible,
                    [record.OrderMasterId]: false,
                }));
                console.error(error);
            });
    };

    const buildKotOrderDetails = (detailInfo = {}, fallback = {}) => {
        const orderDateValue =
            detailInfo?.OrderDateTime ||
            detailInfo?.OrderDate ||
            fallback?.OrderDateTime ||
            fallback?.OrderDate ||
            "";

        return {
            orderModeName:
                detailInfo?.OrderMode ||
                detailInfo?.OrderModeName ||
                fallback?.OrderMode ||
                fallback?.OrderModeName ||
                fallback?.OrderModeValue ||
                "N/A",
            customerName:
                detailInfo?.CustomerName ||
                detailInfo?.CustomerFullName ||
                fallback?.CustomerName ||
                "N/A",
            CompleteAddress:
                detailInfo?.CustomerAddress ||
                detailInfo?.CompleteAddress ||
                fallback?.CustomerAddress ||
                fallback?.CompleteAddress ||
                "",
            PhoneNumber: detailInfo?.PhoneNumber || fallback?.PhoneNumber || "",
            AlternateNumber:
                detailInfo?.AlternateNumber || fallback?.AlternateNumber || "",
            LandMark: detailInfo?.LandMark || fallback?.LandMark || "",
            orderNumber: detailInfo?.OrderNumber || fallback?.OrderNumber || "",
            orderDate:
                orderDateValue || new Date().toISOString().split("Z")[0],
        };
    };

    const buildCheckoutBillOrderDetails = (detailInfo = {}, fallback = {}) => {
        const orderDateValue =
            detailInfo?.OrderDateTime ||
            detailInfo?.OrderDate ||
            fallback?.OrderDateTime ||
            fallback?.OrderDate ||
            "";

        return {
            orderModeName:
                detailInfo?.OrderMode ||
                detailInfo?.OrderModeName ||
                fallback?.OrderMode ||
                fallback?.OrderModeName ||
                fallback?.OrderModeValue ||
                "N/A",
            customerName:
                detailInfo?.CustomerName ||
                detailInfo?.CustomerFullName ||
                fallback?.CustomerName ||
                "N/A",
            address:
                detailInfo?.CustomerAddress ||
                detailInfo?.CompleteAddress ||
                fallback?.CustomerAddress ||
                fallback?.CompleteAddress ||
                "",
            CompleteAddress:
                detailInfo?.CustomerAddress ||
                detailInfo?.CompleteAddress ||
                fallback?.CustomerAddress ||
                fallback?.CompleteAddress ||
                "",
            PhoneNumber: detailInfo?.PhoneNumber || fallback?.PhoneNumber || "",
            AlternateNumber:
                detailInfo?.AlternateNumber || fallback?.AlternateNumber || "",
            LandMark: detailInfo?.LandMark || fallback?.LandMark || "",
            orderNumber: detailInfo?.OrderNumber || fallback?.OrderNumber || "",
            orderDate:
                orderDateValue || new Date().toISOString().split("Z")[0],
            branchName: detailInfo?.BranchName || fallback?.BranchName || "",
            AreaName: detailInfo?.AreaName || fallback?.AreaName || "",
            TotalAmountWithoutGST: detailInfo?.TotalAmountWithoutGST || fallback?.TotalAmountWithoutGST || 0,
            TotalGST: detailInfo?.TotalGST || fallback?.TotalGST || 0,
            DeliveryCharges: detailInfo?.DeliveryCharges || fallback?.DeliveryCharges || 0,
            Discount: detailInfo?.DiscountAmount || detailInfo?.Discount || fallback?.DiscountAmount || fallback?.Discount || 0,
            NetAmount: detailInfo?.TotalAmountWithGST || detailInfo?.NetAmount || fallback?.TotalAmountWithGST || fallback?.NetAmount || 0,
            PaymentMode: detailInfo?.PaymentMode || fallback?.PaymentMode || "N/A",
            PaymentDate: detailInfo?.PaymentDate || fallback?.PaymentDate || null,
            Remarks1: detailInfo?.Remarks1 || fallback?.Remarks1 || "",
        };
    };

    const prepareKotAddItems = (items = []) => {
        if (!Array.isArray(items) || items.length === 0) {
            return [];
        }

        const groupedByRandom = items.reduce((acc, item) => {
            const key =
                item.RandomId ??
                `${item.OrderDetailId || item.ProductDetailId}_${item.ProductDetailId}`;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});

        return Object.values(groupedByRandom).map((group) => {
            const parentRow =
                group.find(
                    (row) =>
                        row.DealItemId === null ||
                        row.DealItemId === 0 ||
                        row.DealItemId === "0"
                ) || group[0];

            const parentItem = {
                id:
                    parentRow.RandomId ||
                    `${parentRow.OrderDetailId || parentRow.ProductDetailId}`,
                quantity: parentRow.Quantity || 1,
                ProductDetailId: parentRow.ProductDetailId,
                name: parentRow.ProductDetailName,
                ProductName: parentRow.ProductDetailName,
                ProductDetailName: parentRow.ProductDetailName,
                SizeName: parentRow.SizeName,
                FlavourName: parentRow.FlavourName,
                DepartmentName:
                    parentRow.DepartmentName ||
                    parentRow.Department ||
                    parentRow.DepartmentTitle ||
                    "General",
                DepartmentId: parentRow.DepartmentId || null,
                dealSelections: {},
            };

            group
                .filter(
                    (row) =>
                        row.DealItemId !== null &&
                        row.DealItemId !== 0 &&
                        row.DealItemId !== "0"
                )
                .forEach((row) => {
                    const dealKey = row.DealItemId || `deal-${parentItem.id}`;
                    if (!Array.isArray(parentItem.dealSelections[dealKey])) {
                        parentItem.dealSelections[dealKey] = [];
                    }
                    parentItem.dealSelections[dealKey].push({
                        name: row.ProductDetailName,
                        ProductDetailName: row.ProductDetailName,
                        Quantity: row.Quantity || 1,
                        SizeName: row.SizeName,
                        FlavourName: row.FlavourName,
                    });
                });

            return parentItem;
        });
    };

    const handleConsolidatedKotPrint = async () => {

        if (!selectedCurrentOrder?.length) {
            message.warning("Please select an order to print KOT.");
            return;
        }

        const order = selectedCurrentOrder[0];

        if (!order?.OrderMasterId) {
            message.error("Selected order is missing required identifiers.");
            return;
        }

        setKotPrintData(null);
        setIsKotLoading(true);

        try {
            const response = await postRequest("getOrderDetail", {
                OperationId: 1,
                CompanyId: userData.CompanyId,
                OrderId: order.OrderMasterId,
                UserId: userData.UserId,
                UserIP: "192.1.1.1",
            });

            const dataSet = response?.data?.DataSet;

            if (!dataSet) {
                throw new Error("Empty order detail dataset");
            }

            const detailRows = dataSet.Table1 || [];
            const kotItems = prepareKotAddItems(detailRows);

            if (!kotItems.length) {
                message.warning("No items available for consolidated KOT.");
                return;
            }

            const kotOrderDetails = buildKotOrderDetails(
                dataSet.Table?.[0] || {},
                order
            );

            setKotPrintData({
                orderDetails: kotOrderDetails,
                orderAddItems: kotItems,
                groupByDepartment: false,
            });
        } catch (error) {
            console.error("Consolidated KOT error:", error);
            message.error("Unable to prepare consolidated KOT. Please try again.");
        } finally {
            setIsKotLoading(false);
        }
    };

    const handleDepartmentKotPrint = async () => {
        if (!selectedCurrentOrder?.length) {
            message.warning("Please select an order to print KOT.");
            return;
        }

        const order = selectedCurrentOrder[0];

        if (!order?.OrderMasterId) {
            message.error("Selected order is missing required identifiers.");
            return;
        }

        setKotPrintData(null);
        setIsDepartmentKotLoading(true);

        try {
            const response = await postRequest("getOrderDetail", {
                OperationId: 1,
                CompanyId: userData.CompanyId,
                OrderId: order.OrderMasterId,
                UserId: userData.UserId,
                UserIP: "192.1.1.1",
            });

            const dataSet = response?.data?.DataSet;

            if (!dataSet) {
                throw new Error("Empty order detail dataset");
            }

            const detailRows = dataSet.Table1 || [];
            const kotItems = prepareKotAddItems(detailRows);

            if (!kotItems.length) {
                message.warning("No items available for department KOT.");
                return;
            }

            const kotOrderDetails = buildKotOrderDetails(
                dataSet.Table?.[0] || {},
                order
            );

            setKotPrintData({
                orderDetails: kotOrderDetails,
                orderAddItems: kotItems,
                groupByDepartment: true,
            });
        } catch (error) {
            console.error("Department KOT error:", error);
            message.error("Unable to prepare department KOT. Please try again.");
        } finally {
            setIsDepartmentKotLoading(false);
        }
    };

    const handleDuplicateCheckoutBill = async () => {
        if (!selectedCurrentOrder?.length) {
            message.warning("Please select an order to print checkout bill.");
            return;
        }

        const order = selectedCurrentOrder[0];

        if (!order?.OrderMasterId) {
            message.error("Selected order is missing required identifiers.");
            return;
        }

        setCheckoutBillData(null);

        try {
            const response = await postRequest("getOrderDetail", {
                OperationId: 1,
                CompanyId: userData.CompanyId,
                OrderId: order.OrderMasterId,
                UserId: userData.UserId,
                UserIP: "192.1.1.1",
            });

            const dataSet = response?.data?.DataSet;

            if (!dataSet) {
                throw new Error("Empty order detail dataset");
            }

            const detailRows = dataSet.Table1 || [];
            const checkoutItems = prepareKotAddItems(detailRows);

            if (!checkoutItems.length) {
                message.warning("No items available for checkout bill.");
                return;
            }

            const checkoutOrderDetails = buildCheckoutBillOrderDetails(
                dataSet.Table?.[0] || {},
                order
            );

            setCheckoutBillData({
                orderDetails: checkoutOrderDetails,
                orderItems: checkoutItems,
            });
        } catch (error) {
            console.error("Duplicate checkout bill error:", error);
            message.error("Unable to prepare checkout bill. Please try again.");
        }
    };

    // Handle tab change
    const handleTabChange = (key) => {
        setIsAllOrders(false);

        // const filteredOrderByStatus = allOrders?.filter(
        //     (status) => status.OrderStatusId === key
        // );

        const filteredOrderByStatus = allOrders?.filter(
            (mode) => mode.OrderModeId === key
        );

        // setFilteredData(filteredOrderByStatus);
        bindOrders(filteredOrderByStatus, showClosedOrderList);
    };

    const getOrderStatusCount = (orderStatusId) => {
        if (!Array.isArray(orderStatusList)) {
            throw new Error("orderStatusList must be an array.");
        }

        const filteredList = allOrders.filter(
            (status) => status.OrderStatusId === orderStatusId
        );

        return filteredList.length;
    };

    const getOrderModeCount = (orderModeId) => {
        if (!Array.isArray(orderModeList)) {
            throw new Error("orderModeList must be an array.");
        }

        const filteredList = allOrders.filter(
            (status) => status.OrderModeId === orderModeId
        );

        return filteredList.length;
    };

    const toggleNewViewOrder = () => {
        setNewViewOrder(!NewviewOrder);
    };


    const DetailPopover = ({ data }) => {
        return (
            <div style={{ borderRadius: "8px" }}>
                <Table
                    size="small"
                    columns={[
                        {
                            title: <span style={{ fontSize: "12px" }}>Product Name</span>,
                            dataIndex: "ProductDetailName",
                            key: "ProductDetailName",
                            className: "custom-header",
                        },
                        {
                            title: <span style={{ fontSize: "12px" }}>Quantity</span>,
                            dataIndex: "Quantity",
                            key: "Quantity",
                            className: "custom-header",
                        },
                        {
                            title: <span style={{ fontSize: "12px" }}>Discount</span>,
                            dataIndex: "DiscountPercent",
                            key: "DiscountPercent",
                            className: "custom-header",
                        },
                        {
                            title: <span style={{ fontSize: "12px" }}>Amount</span>,
                            dataIndex: "PriceWithGST",
                            key: "PriceWithGST",
                            className: "custom-header",
                        },
                    ]}
                    dataSource={
                        data?.Table1?.map((item, index) => ({
                            key: index,
                            ProductDetailName: item.ProductDetailName,
                            Quantity: item.Quantity,
                            DiscountPercent: item.DiscountPercent,
                            PriceWithGST: item.PriceWithGST,
                        })) || []
                    }
                    pagination={false}
                    rowClassName={() => "custom-row no-hover"}
                />
            </div>
        );
    };

    function toggleViewOrder() {
        setViewOrder(!viewOrder);
    }
    // ...

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const handleRowClick = (record, e) => {


        const key = record.OrderMasterId;

        if (e.ctrlKey || e.metaKey) {
            setSelectedRowKeys(prev =>
                prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
            );

            setSelectedCurrentOrder(prev =>
                prev.some(order => order.OrderMasterId === key)
                    ? prev.filter(order => order.OrderMasterId !== key)
                    : [...prev, record]
            );

        }
        else {
            setSelectedRowKeys([key]);

            dispatch({
                type: "POS_SELECTED_ORDER",
                payload: [record]
            });

            setisEnableDuplicateCheckoutBill(false);
            setIsEnableSaleReturn(false);

            setSelectedCurrentOrder([record]);
            setIsEnableGeneralOrderBtns(true);
            setIsEnableOrderTransfer(true);
            setIsEnableTableMerge(true);

            setIsEnableDineInOrderBtns(false);
            setIsEnableTakeAwayOrderBtns(false);
            setIsEnableDeliveryOrderBtns(false);
            setIsEnableTableMerge(false);

            if (record.OrderModeId === 109) {
                setIsEnableDineInOrderBtns(true);
                setIsMergeTableExist(record?.MergeTableName ? true : false);
            }
            else if (record.OrderModeId === 110) {
                setIsEnableTakeAwayOrderBtns(true);
            } else if (record.OrderModeId === 111) {
                setIsEnableDeliveryOrderBtns(true);
            }
            else {
                setIsEnableDineInOrderBtns(false);
                setIsMergeTableExist(false);
            }

            if (record.IsPaid == true || record.IsCancelable == true) {
                setIsEnableDineInOrderBtns(false);
                setIsEnableTakeAwayOrderBtns(false);
                setIsEnableDeliveryOrderBtns(false);
                setIsEnableGeneralOrderBtns(false);
                setIsEnableOrderTransfer(false);
                setIsEnableTableMerge(false);
                setisEnableDuplicateCheckoutBill(true);
                setIsEnableSaleReturn(true);
            }

            if (record.BillPrintCount > 0) {
                setIsEnableOrderTransfer(false);
                setIsEnableTableMerge(false);
            }

            if (selectedRowKeys.includes(key) && selectedRowKeys.length === 1) {
                setSelectedRowKeys([]);

                dispatch({
                    type: "POS_SELECTED_ORDER",
                    payload: []
                });

                setSelectedCurrentOrder([]);
                setIsEnableDineInOrderBtns(false);
                setIsEnableGeneralOrderBtns(false);
                setIsEnableOrderTransfer(false);
                setIsEnableTableMerge(false);

            }
        }
    };

    const toggleTableRiderWaiterModal = () => {

        const open = !tableWaiterRiderModalOpen;
        setTableWaiterRiderModalOpen(open);
    };

    const toggleSaleReturnModal = () => {
        const open = !saleReturnModal;
        setSaleReturnModal(open);
    };

    const togglePettyCashModal = () => {
        const open = !pettyCashModal;
        setPettyCashModal(open);
    };

    const handleUpdate = (newTableList) => {

        if (newTableList) {
            setTableList(newTableList);
        }
        fetchDataFromApi();
    };

    const handleOrderCancelFlow = () => {
        toggleTableRiderWaiterModal();

        const obj = {
            modalFunc: "OrderCancelReason",
            modalTitle: "Order Cancel Reason",
            modalData: orderCancelReason,
            modalSelectedId: selectedCurrentOrder[0]?.OrderCancelReasonId,
            OrderMasterId: selectedRowKeys
        };

        setUpdateTableWaiterRiderModalObj(obj);
    };

    const handleTableMergeFlow = () => {
        toggleTableRiderWaiterModal();
        const obj = {
            modalFunc: "TableMerge",
            modalTitle: "Table Merge",
            modalData: tables.filter(a => a.IsOpen === true &&
                a.BranchId === selectedCurrentOrder[0]?.BranchId
                &&
                a.TableId != selectedCurrentOrder[0]?.TableId
            ),
            modalSelectedId: selectedCurrentOrder[0]?.TableId,
            OrderMasterId: selectedRowKeys
        };
        setUpdateTableWaiterRiderModalObj(obj);
    };

    const handleOrderTransferFlow = () => {
        setIsNewOrderOpen(true);
    };

    const handleSalesReturnFlow = () => {
        if (!selectedCurrentOrder?.length) {
            message.warning("Please select an order for sales return.");
            return;
        }

        const order = selectedCurrentOrder[0];

        if (!order?.OrderMasterId) {
            message.error("Selected order is missing required identifiers.");
            return;
        }

        toggleSaleReturnModal();
    };

    const handleAuthSuccess = () => {
        setIsAuthenticate(true);
        setVisibleAuthModal(false);

        if (pendingAction === "ORDER_DELETE") {
            handleOrderCancelFlow();
        } else if (pendingAction === "TABLE_MERGE") {
            handleTableMergeFlow();
        } else if (pendingAction === "ORDER_TRANSFER") {
            handleOrderTransferFlow();
        } else if (pendingAction === "SALE_RETURN") {
            handleSalesReturnFlow();
        }

        setPendingAction(null);
        setIsAuthenticate(false);
    };

    const handleOrderDeleteClick = (feature) => {
        const featureKey = feature || "ORDER_DELETE";
        setFeatureName(featureKey);
        setPendingAction("ORDER_DELETE");

        if (isAuthenticate) {
            handleOrderCancelFlow();
            setIsAuthenticate(false);
            return;
        }

        const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

        if (!hasPermission) {
            setVisibleAuthModal(true);
            return;
        }

        handleOrderCancelFlow();
        setPendingAction(null);
    };

    const handleTableMergeClick = () => {
        const featureKey = "TABLE_MERGE";
        setFeatureName(featureKey);
        setPendingAction("TABLE_MERGE");

        if (isAuthenticate) {
            handleTableMergeFlow();
            setIsAuthenticate(false);
            return;
        }

        const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

        if (!hasPermission) {
            setVisibleAuthModal(true);
            return;
        }

        handleTableMergeFlow();
        setPendingAction(null);
    };

    const handleOrderTransferClick = () => {
        const featureKey = "ORDER_TRANSFER";
        setFeatureName(featureKey);
        setPendingAction("ORDER_TRANSFER");

        if (isAuthenticate) {
            handleOrderTransferFlow();
            setIsAuthenticate(false);
            return;
        }

        const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

        if (!hasPermission) {
            setVisibleAuthModal(true);
            return;
        }

        handleOrderTransferFlow();
        setPendingAction(null);
    };

    const handleSalesReturnClick = () => {
        const featureKey = "SALE_RETURN";
        setFeatureName(featureKey);
        setPendingAction("SALE_RETURN");

        if (isAuthenticate) {
            handleSalesReturnFlow();
            setIsAuthenticate(false);
            return;
        }

        const hasPermission = checkFeatureAuth(featureKey, undefined, { showErrorMessage: false });

        if (!hasPermission) {
            setVisibleAuthModal(true);
            return;
        }

        handleSalesReturnFlow();
        setPendingAction(null);
    };


    const onClosedOrderListChange = (checked) => {
        setShowClosedOrderList(checked);
        fetchDataFromApi(checked);

        setSelectedRowKeys([]);
        setSelectedCurrentOrder([]);

        setIsEnableButton(false);
        setIsEnableGeneralOrderBtns(false);
        setIsEnableDineInOrderBtns(false);
        setIsEnableTakeAwayOrderBtns(false);
        setIsEnableDeliveryOrderBtns(false);
        setIsEnableOrderTransfer(false);
        setIsEnableTableMerge(false);
        setisEnableDuplicateCheckoutBill(false);
        setIsEnableSaleReturn(false);
    };

    return (
        <>
            <div
                style={{
                    background: "white",
                    padding: 15,
                    boxShadow: "0 0 5px lightgray",
                    borderRadius: 2,
                }}
            >
                <Row>
                    <Col span={21}>


                        <Row
                            style={{ gap: "10px", alignItems: "flex-end" }}
                            gutter={[10, 10]}
                        >

                            <FormButton
                                title="Start"
                                type="primary"
                                onClick={() => {

                                    setIsDayShiftCounterModalVisible(true);
                                    setIsDayShiftCounterCloseModalVisible(false);
                                }
                                }
                                disabled={isEnableButton_NewOrder == true ? true : false}
                            />

                            <FormButton
                                title="Close"
                                type="primary"
                                onClick={() => {
                                    setIsDayShiftCounterModalVisible(true);
                                    setIsDayShiftCounterCloseModalVisible(true);
                                }
                                }
                                disabled={isEnableButton_NewOrder == true ? false : true}
                            />

                            <FormButton
                                title="New Order"
                                type="primary"
                                onClick={() => {
                                    navigate('/orderBooking');
                                }
                                }
                                disabled={!isEnableButton_NewOrder}
                            />

                            {(isDayShiftCounterModalVisible ?? true) && (
                                <DayShiftCounterModal
                                    isDayShiftCounterModalVisible={isDayShiftCounterModalVisible}
                                    setIsDayShiftCounterModalVisible={setIsDayShiftCounterModalVisible}
                                    setDayShiftCounterData={setDayShiftCounterData}
                                    DayShiftCounterData={DayShiftCounterData}
                                    isDayShiftCounterCloseModalVisible={isDayShiftCounterCloseModalVisible}
                                    setIsDayShiftCounterCloseModalVisible={setIsDayShiftCounterCloseModalVisible}
                                />)}

                            <Col span={18}>
                                {orderModeList.length > 0 && (
                                    <nav className="w-full mb-4 flex justify-center">
                                        <div className="flex gap-2 overflow-x-auto px-6 py-2 bg-gray-100 rounded-full shadow-sm max-w-full scrollbar-hide">
                                            <button
                                                key={999}
                                                className={`min-w-max px-4 py-2 rounded-full font-medium text-sm transition-colors duration-200 ${isAllOrders
                                                    ? "bg-[#017971] text-white"
                                                    : "bg-white text-gray-700 hover:bg-[#017971] hover:text-white"
                                                    }`}
                                                onClick={() => {
                                                    setIsAllOrders(true);
                                                    // setFilteredData(allOrders);
                                                    bindOrders(allOrders, showClosedOrderList);
                                                }}
                                            >
                                                All Orders
                                            </button>

                                            {orderModeList
                                                .map((mode) => {
                                                    const isActive =
                                                        selectedOrderMode === mode.OrderMode && !isAllOrders;
                                                    const count = getOrderModeCount(mode.OrderModeId);

                                                    return (
                                                        <button
                                                            key={mode.OrderModeId}
                                                            className={`relative min-w-max px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${isActive
                                                                ? "bg-[#017971] text-white"
                                                                : "bg-white text-gray-700 hover:bg-[#017971] hover:text-white"
                                                                }`}
                                                            onClick={() => {
                                                                handleTabChange(mode.OrderModeId);
                                                                setSelectedOrderMode(mode.OrderMode);
                                                            }}
                                                        >
                                                            {mode.OrderMode}
                                                            {count > 0 && (
                                                                <span
                                                                    className={`absolute -top-2 -right-2 flex items-center justify-center rounded-full text-white text-xs font-bold bg-[#017971] shadow-md ${count > 99 ? "w-[26px] h-[26px]" : "w-[20px] h-[20px]"
                                                                        }`}
                                                                >
                                                                    {count > 99 ? "99+" : count}
                                                                </span>
                                                            )}
                                                        </button>
                                                    );
                                                })}
                                        </div>
                                    </nav>
                                )}
                            </Col>

                            <Col span={2}>
                                <p className="m-0">Closed Order Listing</p>
                            </Col>

                            <Col span={2}>

                                <Switch
                                    className="bg-gray-200"
                                    checked={showClosedOrderList}
                                    onChange={(checked) => onClosedOrderListChange(checked)}
                                    style={{
                                        backgroundColor: showClosedOrderList === true
                                            ? "rgb(1, 121, 113)" : "grey",
                                    }}
                                />
                            </Col>
                        </Row>

                        <Space direction="vertical" size="middle" style={{ display: 'flex' }} >
                            <Row
                                style={{ gap: "10px" }}
                                gutter={[10, 10]}
                            >
                                <Col span={24}>
                                    {/* <Collapse defaultActiveKey={["searchForm"]}> */}
                                    <Collapse defaultActiveKey={null}>
                                        <Panel header="Search Order" key="searchForm">
                                            <form
                                                style={{ gap: "10px", alignItems: "flex-end" }}
                                                onSubmit={handleSearchSubmit}
                                            >
                                                <Row
                                                    style={{ gap: "10px", alignItems: "flex-end" }}
                                                    gutter={[10, 10]}
                                                >
                                                    <FormTextField
                                                        colSpan={5}
                                                        label="Phone No"
                                                        size={INPUT_SIZE}
                                                        name="CustomerPhone"
                                                        onChange={handleSearchFieldChange}
                                                        isNumber="true"
                                                        type="text"
                                                    />

                                                    <FormTextField
                                                        colSpan={5}
                                                        label="Order No"
                                                        size={INPUT_SIZE}
                                                        name="OrderNumber"
                                                        onChange={handleSearchFieldChange}
                                                        isNumber="true"
                                                        type="text"
                                                    />

                                                    <FormTextField
                                                        colSpan={5}
                                                        label="Customer Name"
                                                        size={INPUT_SIZE}
                                                        name="CustomerName"
                                                        onChange={handleSearchFieldChange}
                                                    />

                                                    <FormSelect
                                                        colSpan={5}
                                                        listItem={orderStatusList}
                                                        idName="OrderStatusId"
                                                        valueName="OrderStatus"
                                                        size={INPUT_SIZE}
                                                        name="StatusId"
                                                        label="Status"
                                                        value={searchFields.StatusId || ""}
                                                        onChange={handleSelectChange}
                                                    />

                                                    <FormSelect
                                                        colSpan={5}
                                                        // listItem={branchList}
                                                        listItem={userBranchList}
                                                        idName="BranchId"
                                                        valueName="BranchName"
                                                        size={INPUT_SIZE}
                                                        name="BranchId"
                                                        label="Branch"
                                                        value={searchFields.BranchId || ""}
                                                        onChange={handleSelectChange}
                                                        addSelectOption={userBranchList.length === 1 ? false : true}
                                                    />

                                                    <FormSelect
                                                        colSpan={5}
                                                        listItem={areaList}
                                                        idName="AreaId"
                                                        valueName="AreaName"
                                                        size={INPUT_SIZE}
                                                        name="AreaId"
                                                        label="Area"
                                                        value={searchFields.AreaId || ""}
                                                        onChange={handleSelectChange}
                                                    />

                                                    <FormSelect
                                                        colSpan={5}
                                                        listItem={orderSourceList}
                                                        idName="OrderSourceId"
                                                        valueName="OrderSource"
                                                        size={INPUT_SIZE}
                                                        name="OrderSourceId"
                                                        label="Order Source"
                                                        value={searchFields.OrderSourceId || ""}
                                                        onChange={handleSelectChange}
                                                    />

                                                    <FormTextField
                                                        type="date"
                                                        style={{ width: "100%" }}
                                                        label="Date From"
                                                        name="DateFrom"
                                                        placeholder="MM/DD/YYYY"
                                                        ref={dateFromRef}
                                                        onChange={(dateValue) => {

                                                            setSearchFields({
                                                                ...searchFields,
                                                                DateFrom: dateValue.value,
                                                            });
                                                        }}
                                                    />

                                                    <FormTextField
                                                        type="date"
                                                        style={{ width: "100%" }}
                                                        label="Date To"
                                                        name="DateTo"
                                                        placeholder="MM/DD/YYYY"
                                                        ref={dateToRef}
                                                        onChange={(dateValue) => {

                                                            setSearchFields({
                                                                ...searchFields,
                                                                DateTo: dateValue.value,
                                                            });
                                                        }}
                                                    />

                                                    <FormButton
                                                        title="Search"
                                                        type="primary"
                                                        icon={loading ? <LoadingOutlined /> : <SearchOutlined />}
                                                        htmlType="submit"
                                                    />



                                                </Row>
                                            </form>
                                        </Panel>
                                    </Collapse>
                                </Col>
                            </Row>
                        </Space>





                        <Row
                            style={{ gap: "10px" }}
                            gutter={[10, 10]}
                        >
                            <Col span={24}>
                                <div ref={tableRef}>
                                    {/* Column Filter Row */}
                                    <div style={{
                                        background: "#fafafa",
                                        border: "1px solid #f0f0f0",
                                        borderBottom: "none",
                                        borderRadius: "4px 4px 0 0",
                                        position: "relative",
                                        overflow: "hidden"
                                    }}>
                                        <div style={{
                                            position: "absolute",
                                            top: "8px",
                                            right: "16px",
                                            zIndex: 10
                                        }}>
                                            <Button
                                                size="small"
                                                onClick={clearAllFilters}
                                                type="link"
                                                style={{ fontSize: "12px", padding: "0 4px" }}
                                            >
                                                Clear All
                                            </Button>
                                        </div>
                                        <div style={{
                                            display: "table",
                                            width: "100%",
                                            tableLayout: "auto",
                                            paddingRight: "80px"
                                        }}>
                                            <div style={{ display: "table-row" }}>
                                                {columns.map((col, index) => {
                                                    // Map dataIndex to filter key
                                                    const filterKey = col.dataIndex === "x" ? null : col.dataIndex;
                                                    const hasFilter = filterKey && columnFilters.hasOwnProperty(filterKey);

                                                    return (
                                                        <div
                                                            key={col.key || index}
                                                            style={{
                                                                display: "table-cell",
                                                                padding: "8px 16px",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            {hasFilter ? (
                                                                <Input
                                                                    placeholder={col.title}
                                                                    value={columnFilters[filterKey] || ""}
                                                                    onChange={(e) => handleColumnFilterChange(filterKey, e.target.value)}
                                                                    size="small"
                                                                    allowClear
                                                                    style={{ width: "100%" }}
                                                                />
                                                            ) : null}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <Table
                                        loading={loading}
                                        columns={columns}
                                        dataSource={filteredData}
                                        rowKey="OrderMasterId"
                                        rowSelection={{
                                            selectedRowKeys,
                                            type: 'checkbox',
                                            onChange: (newSelectedKeys) => setSelectedRowKeys(newSelectedKeys),
                                            columnWidth: 0, // Hides the checkbox column
                                            renderCell: () => null, // Prevent checkbox from rendering
                                            columnTitle: () => null,
                                        }}
                                        onRow={(record) => ({
                                            onClick: (e) => handleRowClick(record, e),
                                        })}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                        <Space direction="vertical" size="middle">

                            <FormButton
                                title="Table Transfer"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={() => {
                                    toggleTableRiderWaiterModal();

                                    const obj = {
                                        modalFunc: "TableTransfer",
                                        modalTitle: "Table Transfer",
                                        modalData: tables.filter(a => a.IsOpen === false &&
                                            a.BranchId === selectedCurrentOrder[0]?.BranchId
                                            // &&
                                            // a.TableId != selectedCurrentOrder[0]?.TableId
                                        ),
                                        modalSelectedId: selectedCurrentOrder[0]?.TableId,
                                        OrderMasterId: selectedRowKeys
                                    };

                                    setUpdateTableWaiterRiderModalObj(obj);
                                }}
                                disabled={!isEnableDineInOrderBtns}
                            />

                            {!isMergeTableExist ?
                                <>
                                    <FormButton
                                        title="Table Merge"
                                        type="primary"
                                        // style={{ width: '150px' }}
                                        className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                        onClick={handleTableMergeClick}
                                        disabled={!isEnableTableMerge}
                                    />
                                </>
                                :
                                <>
                                    <FormButton
                                        title="Table UnMerge"
                                        type="primary"
                                        // style={{ width: '150px' }}
                                        className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                        onClick={() => {

                                            let orderMasterId = selectedRowKeys[0] ?? 0;

                                            if (orderMasterId > 0) {
                                                postRequest("/UpdateCoverWaiterRider", {
                                                    OperationId: 7,
                                                    CompanyId: userData.CompanyId,
                                                    UserId: userData.UserId,
                                                    UserIP: "1.2.2.1",
                                                    OrderMasterId: orderMasterId,
                                                    // RiderId: riderId,
                                                    // WaiterId: waiterId,
                                                    // TableId: tableId,
                                                    BranchId: selectedCurrentOrder[0]?.BranchId
                                                })
                                                    .then((response) => {
                                                        if (response?.error === true) {
                                                            message.error(response?.errorMessage);
                                                            return;
                                                        }
                                                        if (response?.data?.response === false) {
                                                            message.error(response?.DataSet?.Table?.errorMessage);
                                                            return;
                                                        }
                                                        message.success(response.successMessage);

                                                        handleUpdate(response?.data?.DataSet?.Table3);


                                                        dispatch({ type: "REFRESH_STATS", payload: 1 });
                                                    })
                                                    .catch((error) => { });
                                            }
                                        }}
                                        disabled={!isEnableDineInOrderBtns}
                                    />
                                </>
                            }

                            <FormButton
                                title="Assign / Change Waiter"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={() => {
                                    toggleTableRiderWaiterModal();
                                    const obj = {
                                        modalFunc: "ChangeWaiter",
                                        modalTitle: "Assign / Change Waiter",
                                        modalData: waiters,
                                        modalSelectedId: selectedCurrentOrder[0]?.WaiterId,
                                        OrderMasterId: selectedRowKeys
                                    };
                                    setUpdateTableWaiterRiderModalObj(obj);
                                }}
                                disabled={!isEnableDineInOrderBtns}
                            />

                            <FormButton
                                title="Assign / Change Rider"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={() => {
                                    toggleTableRiderWaiterModal();
                                    const obj = {
                                        modalFunc: "ChangeRider",
                                        modalTitle: "Assign / Change Rider",
                                        modalData: riders,
                                        modalSelectedId: selectedCurrentOrder[0]?.RiderId,
                                        OrderMasterId: selectedRowKeys,

                                    };
                                    setUpdateTableWaiterRiderModalObj(obj);
                                }}
                                disabled={!isEnableDeliveryOrderBtns}
                            />

                            {tableWaiterRiderModalOpen && (
                                <UpdateTableWaiterRiderModal
                                    updateTableWaiterRiderModalObj={updateTableWaiterRiderModalObj}
                                    setUpdateTableWaiterRiderModalObj={setUpdateTableWaiterRiderModalObj}
                                    userData={userData}
                                    toggleTableRiderWaiterModal={toggleTableRiderWaiterModal}
                                    tableWaiterRiderModalOpen={tableWaiterRiderModalOpen}
                                    selectedCurrentOrder={selectedCurrentOrder}
                                    handleUpdate={handleUpdate}
                                />)}

                            <FormButton
                                title="Order Transfer"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={handleOrderTransferClick}
                                disabled={!isEnableOrderTransfer}
                            />

                            <NewOrderDialog
                                open={isNewOrderOpen}
                                onOpenChange={null}
                                onSubmit={() => {
                                    setIsNewOrderOpen(false);
                                    fetchDataFromApi();
                                }}
                                popupTitle="Order Transfer"
                                orderMasterId={selectedRowKeys[0] ?? null}
                            />

                            <FormButton
                                title="Consolidated KOT"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={handleConsolidatedKotPrint}
                                disabled={!isEnableGeneralOrderBtns}
                                loading={isKotLoading}
                            />

                            <FormButton
                                title="Duplicate KOT"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={handleDepartmentKotPrint}
                                disabled={!isEnableGeneralOrderBtns}
                                loading={isDepartmentKotLoading}
                            />

                            <FormButton
                                title="Order Cancel"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={() => handleOrderDeleteClick("ORDER_DELETE")}
                                disabled={!isEnableGeneralOrderBtns}
                            />

                            <FormButton
                                title="Duplicate Checkout Bill"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={handleDuplicateCheckoutBill}
                                disabled={!isEnableDuplicateCheckoutBill}
                            />

                            <FormButton
                                title="Sales Return"
                                type="primary"
                                // style={{ width: '150px' }}
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={handleSalesReturnClick}
                                disabled={!isEnableSaleReturn}
                            />

                            <FormButton
                                title="Petty Cash"
                                type="primary"
                                className="w-full w-20 h-20 aspect-square bg-primary hover:bg-primary 
                                text-white flex flex-col items-center justify-center gap-1 text-xs"
                                onClick={togglePettyCashModal}
                            />

                            <AuthLoginModal
                                setVisible={setVisibleAuthModal}
                                visible={visibleAuthModal}
                                featureName={featureName}
                                onSuccess={handleAuthSuccess}
                                menuName={menuName}
                            />

                            {kotPrintData && (
                                <KotPrint
                                    orderDetails={kotPrintData.orderDetails}
                                    orderAddItems={kotPrintData.orderAddItems}
                                    orderLessItems={[]}
                                    addHeading={"Consolidated KOT"}
                                    groupByDepartment={Boolean(kotPrintData.groupByDepartment)}
                                    onComplete={() => setKotPrintData(null)}
                                    isDuplicate={Boolean(kotPrintData.groupByDepartment) == true ? true : false}
                                />
                            )}

                            {checkoutBillData && (
                                <OrderCheckoutBill
                                    ref={checkoutBillRef}
                                    orderDetails={checkoutBillData.orderDetails}
                                    orderItems={checkoutBillData.orderItems}
                                    heading="DUPLICATE CHECKOUT BILL"
                                    onAfterPrint={() => {
                                        setCheckoutBillData(null);
                                    }}
                                />
                            )}

                            <SalesReturnModal
                                open={saleReturnModal}
                                onClose={toggleSaleReturnModal}
                                selectedOrder={selectedCurrentOrder?.[0] || null}
                                onSuccess={() => {
                                    fetchDataFromApi(showClosedOrderList);
                                }}
                            />

                            <PettyCashPage
                                open={pettyCashModal}
                                onClose={togglePettyCashModal}
                            />

                        </Space>
                    </Col>
                </Row>
            </div >
        </>
    );
}

export default OrderRecall;
